import MenuBookIcon from '@mui/icons-material/MenuBook';
import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';
import useLocale from '@/shared/hooks/useLocale';
import {getLocalizedUrl} from './utils/getLocalizedUrl';

type Props = {
  href: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

export default function InvestigatorManualButton({href, size, color = 'inherit'}: Props) {
  const {t} = useTranslation(['shared/common']);
  const locale = useLocale();
  const localizedHref = getLocalizedUrl(href, locale);

  return (
    <Button
      component="a"
      variant="outlined"
      color={color}
      startIcon={<MenuBookIcon />}
      fullWidth
      href={localizedHref}
      target="_blank"
      rel="noopener noreferrer"
      size={size}
      data-testid="investigatorManualButton"
    >
      {t('shared/common:manual')}
    </Button>
  );
}
